import React from 'react';

export default class Page9 extends React.Component {

    _savePageStatus = (nextPage) => () => {

        this.props.handleChangeMainPage(nextPage)();

        if (this.props.incompletePage)
            this.props.savePageStatus()('HowToIdentifyYourPersonalMeaning');
    }

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">

                                            <div className="circle_title-first"><img
                                                src={require('@images/browndot.jpg')}
                                                alt=""/>Further Information
                                            </div>
                                            <div className="paraspace"><p>If you found this tool useful then you
                                                are likely to find the following tools both insightful and
                                                relevant:</p></div>
                                            <div className="keyquestionpad">
                                                <ul className="greenbullet-list sept">
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToIdentifyPersonalLearningStyles')}>How
                                                        to identify personal learning styles</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToFocusOnTheBiggerPicture')}>How
                                                        to focus on the bigger picture</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToMakeEthicalDecisions')}>How
                                                        to make ethical decisions</div></li>
                                                    <li><div className="link_color button-link-redirect people"
                                                           onClick={this._savePageStatus('HowToGetTheMostOutOfYourself')}>How
                                                        to get the most out of yourself.</div></li>
                                                </ul>
                                            </div>
                                            <div className="circle_title "><img
                                                src={require('@images/browndot.jpg')}
                                                alt=""/>REFERENCES
                                            </div>

                                            <ol className="testclass">
                                                <li><p className="further_info_content">Allen, M., Gupta,
                                                    R. &amp; Monnier, A. (2008). The Interactive Effect of
                                                    Cultural Symbols and Human Values on Taste Evaluation.<span
                                                        className="subtiltereg"> Journal of Consumer Research,</span> 35,
                                                    294-308.</p></li>
                                                <li><p className="further_info_content">Huynh, Q.
                                                    L., &amp; Banaji, M. R. (2012).<span
                                                        className="subtiltereg">  Handbook of Self and Identity </span> 2nd
                                                    ed.</p></li>
                                                <li><p className="further_info_content">Roberts, L. M., Cha, S.
                                                    E., Hewlin, P. F., &amp; Settles, I. H. (2012). Bringing the
                                                    inside out: Enhancing authenticity and positive identity in
                                                    organizations.<span className="subtiltereg">  Exploring Positive Identities and Organizations,</span> 149.
                                                </p></li>
                                                <li><p className="further_info_content">Myers, I. B.
                                                    (1962).<span className="subtiltereg">  The Myers-Briggs Type Indicator.</span> Consulting
                                                    Psychologists Press.</p></li>

                                            </ol>


                                            <div className="left-btn">
                                                <div onClick={this.props.handleChangePage('Page8')}
                                                     className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this._savePageStatus('People')}
                                                    className="button-next-previous-done">Done
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}